import { Component, OnInit } from '@angular/core';
import { SwapiService, Request } from './swapi.service';

import { Film } from 'models/film';
import { Person } from 'models/person';
import { Planet } from 'models/planet';
import { Species } from 'models/species';
import { Starship } from 'models/starship';
import { Vehicle } from 'models/vehicle';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  films : Request = new Request();
  people : Request = new Request();
  starships : Request = new Request();
  vehicles : Request = new Request();
  species : Request = new Request();
  planets : Request = new Request();
  title = 'app works!';
  filmTitle = 'Films';
  peopleTitle = 'People';
  starshipTitle = 'Starships'
  vehicleTitle = 'Vehicles';
  speciesTitle = 'Species';
  planetsTitle = 'Planets';

  searchString : string = '';
  selected : any;
  itemSelected : boolean = false;
  constructor(private swapiService: SwapiService){

  }

  ngOnInit(): void {
    this.setData();
  }

  search(e){
    this.setData();
  }

  setData(){
    this.swapiService.getFilms(this.searchString).then(films => {
      this.films = films;
    });

    this.swapiService.getPeople(this.searchString).then(people => {
      this.people = people;
    });

    this.swapiService.getStarships(this.searchString).then(starships => this.starships = starships);
    this.swapiService.getVehicles(this.searchString).then(vehicles => this.vehicles = vehicles);
    this.swapiService.getSpecies(this.searchString).then(species => this.species = species);
    this.swapiService.getPlanets(this.searchString).then(planets => this.planets = planets);
  }

  itemSelect(item : any ){
    this.selected = item;
    this.itemSelected = true;
  }

  deselectItem(item:any){
    this.itemSelected = false;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts